<div class="elevator-container" *ngFor="let elevator of elevatorBankData">
  <!--  Default for elevator is empty, 'nostop' means thin line, 'stop' means thick line -->
  <div
    class="elevator"
    [ngClass]="{
      stop: elevator.elevatorType !== elevatorType.Empty && elevator.elevatorType !== elevatorType.ThinLine,
      nostop: elevator.elevatorType === elevatorType.ThinLine,
    }"
  ></div>
  <div class="ev-start" *ngIf="elevator.elevatorType === elevatorType.Start">
    <span class="icon-ev-start"></span>
  </div>
  <!-- if requires icon only on last stop, remove elevator type elevatorType.Stop condition -->
  <div
    class="ev-stop"
    *ngIf="elevator.elevatorType === elevatorType.Stop || elevator.elevatorType === elevatorType.LastStop"
  >
    <mat-icon svgIcon="elevator" aria-hidden="false"></mat-icon>
  </div>
</div>
